// extracted by mini-css-extract-plugin
export default {"propertySize":"styles_propertySize__j0qzH","to":"styles_to__suh3L"};